import { render, staticRenderFns } from "./TournamentLink.vue?vue&type=template&id=0b8df2d1&"
import script from "./TournamentLink.vue?vue&type=script&lang=js&"
export * from "./TournamentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports